__turbopack_context__.v({
  "socialMediaLinksButton": "dMocEW_socialMediaLinksButton",
});
